export default __webpack_public_path__ + "static/media/locked.d3b5b1ed.png";